export const GET_ALL_MODAL_TABLE_LOADING = 'GET_ALL_MODAL_TABLE_LOADING'
export const GET_ALL_MODAL_TABLE_SUCCESS = 'GET_ALL_MODAL_TABLE_SUCCESS'
export const GET_ALL_MODAL_TABLE_ERROR = 'GET_ALL_MODAL_TABLE_ERROR'
export const GET_ALL_MODAL_TABLE_EMPTY = 'GET_ALL_MODAL_TABLE_EMPTY'


export const UPDATE_MODAL_TABLE_LOADING='UPDATE_MODAL_TABLE_LOADING'
export const UPDATE_MODAL_TABLE_SUCCESS='UPDATE_MODAL_TABLE_SUCCESS'
export const UPDATE_MODAL_TABLE_ERROR='UPDATE_MODAL_TABLE_ERROR'